<template lang="pug">

.card.mb-5.mb-xl-10
  .card-body.pt-9.pb-0
    .d-flex.flex-wrap.flex-sm-nowrap.mb-3
      .me-7.mb-4
        .symbol.symbol-100px.symbol-lg-160px.symbol-fixed.position-relative
          span.symbol-label.bg-light.display-1
            | {{ initials(name || website) }}
      .flex-grow-1
        .d-flex.justify-content-between.align-items-start.flex-wrap.mb-2
          .d-flex.flex-column
            .d-flex.align-items-center.mb-2
              a.text-gray-800.text-hover-primary.fs-2.fw-bolder.me-1(href='#') {{ name }}
              .badge.fw-bolder.ml-4(:class="detailsToShow.status.account == 'active' ? 'badge-light-success' : 'badge-light-danger'") {{ getSiteState }}
              a(href='#')
                span.svg-icon.svg-icon-1.svg-icon-primary
                  inline-svg(src='media/icons/duotune/general/gen026.svg')
            .d-flex.flex-wrap.fw-bold.fs-6.mb-4.pe-2
              //
                <a
                href="#"
                class="
                d-flex
                align-items-center
                text-gray-400 text-hover-primary
                me-5
                mb-2
                "
                >
                <span class="svg-icon svg-icon-4 me-1">
                <inline-svg
                src="media/icons/duotune/communication/com006.svg"
                />
                </span>
                owner.name
                </a>
              //
                <a
                href="#"
                class="
                d-flex
                align-items-center
                text-gray-400 text-hover-primary
                me-5
                mb-2
                "
                >
                <span class="svg-icon svg-icon-4 me-1">
                <inline-svg src="media/icons/duotune/general/gen018.svg" />
                </span>
                SF, Bay Area
                </a>
              a.d-flex.align-items-center.text-gray-400.text-hover-primary.mb-2(:href='website' target="_blank")
                span.svg-icon.svg-icon-4.me-1
                  inline-svg(src='media/icons/duotune/communication/com011.svg')
                |                   {{ website }}
          .d-flex.my-4
            button.btn.btn-sm.me-2(:class="detailsToShow.status.account == 'active' ? 'btn-danger' : 'btn-success'" @click="showModalActivateSite")
              | {{ getButtonLabel }}
            button#kt_user_follow_button.btn.btn-sm.btn-light.me-2(data-bs-toggle='modal' data-bs-target='#modalInstalation')
              span.svg-icon.svg-icon-3.d-none
                inline-svg(src='media/icons/duotune/arrows/arr012.svg')
              |                 Instalação
            button#kt_user_follow_button.btn.btn-sm.bg-light-success.btn-light.me-2(@click="recrawlerFunction" v-permission:account-reCrawler)
              span.svg-icon.svg-icon-3.d-none
                inline-svg(src='media/icons/duotune/arrows/arr012.svg')
              |                 Re-escanear
            button.btn.btn-sm.btn-primary.me-3(href='#' data-bs-toggle='modal' data-bs-target='#kt_modal_edit_site')
              | Editar
        .d-flex.flex-wrap.flex-stack
          .d-flex.flex-column.flex-grow-1.pe-8
            .d-flex.flex-wrap
              .border.border-gray-300.border-dashed.rounded.min-w-125px.py-3.px-4.me-6.mb-3
                .d-flex.align-items-center
                  span.svg-icon.svg-icon-success.me-2
                    inline-svg(src='media/icons/duotune/arrows/arr066.svg')
                  .fs-2.fw-bolder(data-kt-countup='true' data-kt-countup-value='4500' data-kt-countup-prefix='$')
                    | {{ stats.views }}
                .fw-bold.fs-6.text-gray-400
                  | Total de visualizações
              .border.border-gray-300.border-dashed.rounded.min-w-125px.py-3.px-4.me-6.mb-3
                .d-flex.align-items-center
                  span.svg-icon.svg-icon-3.svg-icon-danger.me-2
                    inline-svg(src='media/icons/duotune/arrows/arr065.svg')
                  .fs-2.fw-bolder(data-kt-countup='true' data-kt-countup-value='75')
                    | {{ stats.total }}
                .fw-bold.fs-6.text-gray-400 Consentimentos
              .border.border-gray-300.border-dashed.rounded.min-w-125px.py-3.px-4.me-6.mb-3
                .d-flex.align-items-center
                  span.svg-icon.svg-icon-3.svg-icon-success.me-2
                    inline-svg(src='media/icons/duotune/arrows/arr066.svg')
                  .fs-2.fw-bolder(data-kt-countup='true' data-kt-countup-value='60' data-kt-countup-prefix='%')
                    | {{ stats.cookies }}
                .fw-bold.fs-6.text-gray-400 Cookies
              .border.border-gray-300.border-dashed.rounded.min-w-125px.py-3.px-4.me-6.mb-3
                .d-flex.align-items-center
                  span.svg-icon.svg-icon-3.svg-icon-success.me-2
                    inline-svg(src='media/icons/duotune/arrows/arr066.svg')
                  .fs-2.fw-bolder(data-kt-countup='true' data-kt-countup-value='60' data-kt-countup-prefix='%')
                    | {{ configs.type }}
                .fw-bold.fs-6.text-gray-400 Banner
          .d-flex.align-items-center.w-200px.w-sm-300px.flex-column.mt-3
            .d-flex.justify-content-between.w-100.mt-auto.mb-2
              span.fw-bold.fs-6.text-gray-400 Concluído
              span.fw-bolder.fs-6 {{ calcPercent }}%
            .h-5px.mx-3.w-100.bg-light.mb-3
              .bg-success.rounded.h-5px(role='progressbar' :style='styleProgress' :aria-valuenow='calcPercent' aria-valuemin='0' aria-valuemax='100')
    .d-flex.overflow-auto.h-55px
      ul.nav.nav-stretch.nav-line-tabs.nav-line-tabs-2x.border-transparent.fs-5.fw-bolder.flex-nowrap
        li.nav-item
          router-link.nav-link.text-active-primary.me-6(:to="{ name: 'siteDetails', params: { id: siteId } }" active-class='active')
            | Visão geral
        li.nav-item
          router-link.nav-link.text-active-primary.me-6(:to="{ name: 'siteDetailsCookies', params: { id: siteId } }" active-class='active')
            | Cookies
        li.nav-item
          router-link.nav-link.text-active-primary.me-6(:to="{ name: 'siteDetailsConsents', params: { id: siteId } }" active-class='active')
            | Consentimentos
        li.nav-item
          router-link.nav-link.text-active-primary.me-6(:to="{ name: 'siteBanner', params: { id: siteId } }" active-class='active')
            | Banner
        //
          <li class="nav-item">
          <router-link
          to="/crafted/account/settings"
          class="nav-link text-active-primary me-6"
          active-class="active"
          >
          Equipe
          </router-link>
          </li>
          <li class="nav-item">
          <router-link
          to="/crafted/account/settings"
          class="nav-link text-active-primary me-6"
          active-class="active"
          >
          Atividades
          </router-link>
          </li>
ModalInstalation(:details='details')
ModalEditSite(:site="details" @newGet="updateSite")
ModalToggleActivation(:site="details" @update="updateSiteStatus")

</template>

<script>
import { toRef, ref, onMounted } from "vue";
import { Modal } from "bootstrap";
import { useAcl } from "vue-simple-acl/dist/vue-simple-acl.vue2";
import { recrawler } from "@/core/services/consensu/sites";
import ModalInstalation from "./modal/instalation.vue";
import ModalEditSite from "./modal/edit-site.vue";
import ModalToggleActivation from "./modal/toggle-activation-site.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "SiteHeader",

  components: {
    ModalInstalation,
    ModalEditSite,
    ModalToggleActivation,
  },

  props: {
    details: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const acl = useAcl();

    const detailsToShow = toRef(props, "details");

    const canActivate = ref();
    const modalActivateSite = ref();

    const showModalActivateSite = () => {
      modalActivateSite.value.show();
    };

    const setModalActivateSiteAcl = async () => {
      canActivate.value = await acl.can("add-site");

      const modalId = canActivate.value
        ? "kt_modal_toggle_activation_site"
        : "kt_modal_upgrade_plan";

      modalActivateSite.value = new Modal(document.getElementById(modalId), {});
    };

    const updateSiteStatus = () => {
      document.location.reload();
    };

    const initials = (item) => {
      return item
        .match(/(^\S\S?|\b\S)?/g)
        .join("")
        .match(/(^\S|\S$)?/g)
        .join("")
        .toUpperCase();
    };

    const recrawlerFunction = () => {
      recrawler(detailsToShow.value._id)
        .then(() => {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Re-escanear executado com sucesso",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch(() => {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Re-escanear falhou, tente novamente.",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    };

    onMounted(() => {
      setModalActivateSiteAcl();
    });

    return {
      detailsToShow,
      initials,
      updateSiteStatus,
      recrawlerFunction,
      showModalActivateSite,
    };
  },

  computed: {
    getSiteState() {
      return this.detailsToShow.status.account == "active"
        ? "Ativo"
        : "Desativado";
    },

    getButtonLabel() {
      return this.detailsToShow.status.account == "active"
        ? "Desativar"
        : "Ativar";
    },

    siteId() {
      return this.$route.params.id;
    },

    name() {
      return this.detailsToShow.name || "";
    },

    website() {
      return this.detailsToShow.website || "";
    },

    stats() {
      return this.detailsToShow.stats || {};
    },

    consent() {
      return this.detailsToShow.consent || {};
    },

    configs() {
      return this.consent.configs || {};
    },

    calcPercent() {
      let keys = Object.keys(this.details.steps);
      let sum = 100 / keys.length;
      let total = 0;
      keys.forEach((step) => {
        if (this.details.steps[step]) total = total + sum;
      });

      return total;
    },

    styleProgress() {
      return `width: ${this.calcPercent}%`;
    },
  },

  methods: {
    updateSite(payload) {
      this.detailsToShow.name = payload.name;
      this.detailsToShow.website = payload.website;
      this.detailsToShow.title = payload.title;
    },
  },
};
</script>

<style></style>
